import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/anime';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <a
            href="/"
            className="flex items-center gap-2 cursor-pointer"
            onClick={(e) => { e.preventDefault(); navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl text-primary-500"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-950 whitespace-nowrap">
              {siteInfo.name}
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="/"
              onClick={(e) => { e.preventDefault(); navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/') ? 'text-primary-500 bg-primary-100/70' : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              首页
            </a>
            {categories.slice(0, 4).map((cat) => (
              <a
                key={cat.id}
                href={`/category/${cat.slug}`}
                onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'text-primary-500 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </a>
            ))}
            <a
              href="/about"
              onClick={(e) => { e.preventDefault(); navigate('/about'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about') ? 'text-primary-500 bg-primary-100/70' : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              关于我们
            </a>
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            <a
              href="/"
              onClick={(e) => { e.preventDefault(); navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className={`block px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${
                isActive('/') ? 'text-primary-500 bg-primary-100/70' : 'text-foreground-700'
              }`}
            >
              首页
            </a>
            {categories.map((cat) => (
              <a
                key={cat.id}
                href={`/category/${cat.slug}`}
                onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                className={`block px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'text-primary-500 bg-primary-100/70'
                    : 'text-foreground-700'
                }`}
              >
                {cat.name}
              </a>
            ))}
            <a
              href="/about"
              onClick={(e) => { e.preventDefault(); navigate('/about'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className={`block px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${
                isActive('/about') ? 'text-primary-500 bg-primary-100/70' : 'text-foreground-700'
              }`}
            >
              关于我们
            </a>
          </div>
        </div>
      )}
    </header>
  );
}